import { clsx } from 'clsx';
import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router';

import { useModalStore } from '@/store';

import cn from './styles.module.sass';

interface IPageHeadingProps {
    pageName: string;
    isFiltersOpen?: boolean;
    backToPrevLocation?: boolean;
}

export const PageHeading = ({ pageName, isFiltersOpen, backToPrevLocation }: IPageHeadingProps) => {
    const location = useLocation();
    const { setIsOpen, setIsAuthHidden, setIsPurchaseOpen } = useModalStore();

    const wasAuthOpen = location.state?.wasAuthOpen;
    const wasPurchaseOpen = location.state?.wasPurchaseOpen;

    const isBack = useRef(false);

    const handleClick = () => {
        if (wasPurchaseOpen) {
            setIsPurchaseOpen(true);
        }

        isBack.current = true;
    };

    useEffect(() => {
        return () => {
            if (wasAuthOpen) {
                if (['/terms-of-service', '/privacy-policy'].includes(window.location.pathname)) {
                    return
                }

                setIsAuthHidden(false);
                setIsOpen(isBack.current);
            }
        };
    }, []);

    return (
        <div className={clsx(cn.container, isFiltersOpen && cn.hide)}>
            <Link
                to={
                    backToPrevLocation && location.state && 'prevLocation' in location.state
                        ? location.state.prevLocation
                        : '..'
                }
                className={cn.backBtn}
                state={{
                    wasAuthOpen: wasAuthOpen ? !wasAuthOpen : undefined,
                    wasPurchaseOpen: wasPurchaseOpen ? !wasPurchaseOpen : undefined,
                    chosenNumber: location.state?.chosenNumber,
                    activeTariffSid: location.state?.activeTariffSid,
                }}
                onClick={handleClick}
            >
                <img src="/images/main/arrow_dark.svg" alt="" />
            </Link>
            <h2>{pageName}</h2>
        </div>
    );
};
